/**
 * Formats a view count into a human-readable string,
 * e.g. "140 views", "69K views", "1M views".
 *
 * @param views - The number of views.
 * @returns The formatted view count string.
 */
export function formatViews(views: number): string {
  type Unit = { value: number; symbol: string };

  const units: Unit[] = [
    { value: 1e9, symbol: 'B' },
    { value: 1e6, symbol: 'M' },
    { value: 1e3, symbol: 'K' },
  ];

  for (const { value, symbol } of units) {
    if (views >= value) {
      // Floor to the nearest whole unit (no decimals)
      const formatted = Math.floor(views / value);
      return `${formatted}${symbol} views`;
    }
  }

  // Fallback for views < 1000
  return `${views} views`;
}

// Example usage:
// console.log(formatViews(140));      // "140 views"
// console.log(formatViews(69000));    // "69K views"
// console.log(formatViews(1200000));  // "1.2M views"
